<template>
  <v-card>
    <v-card-title class="headline py-2">
      Выбрать признаки для фильтра
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs12 sm6>
          <p>Все признаки</p>
          <v-treeview v-model="tree" :items="allProps" selected-color="primary" selectable return-object>
            <template slot="prepend" slot-scope="{ item, open, leaf }">
              <v-icon size="20" class="mx-0" :color="item.iconcolor">{{item.icon}}</v-icon>
            </template>
            <label slot="label" class="pointer" slot-scope="{item}" @click="">{{item.name}}</label>
          </v-treeview>
        </v-flex>
        
        <v-flex xs12 sm6 style="position: relative">
          <div class="properties-sticky-resultblock">
            <p>Результат</p>
            <span>{{result}}</span>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit">Ok</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import LineConstructor from '../../Common/LineConstructor'
  import {mapState} from 'vuex'
  
  export default {
    name : "FilterPropertiesForm",
  
    components: {
      LineConstructor
    },
    
    props : {
      data:{
        type: Array,
        required: false,
        default: () => []
      }
    },
  
    created(){
      this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
        this.treedata = usersTree
        this.$nextTick(function(){
          this.data.map(item => {
            let id = (item.element_type==='property') ? item.property_id : item.identified
            this.tree.push({id})
          })
        })
      })
    },
    
    computed:{
      ...mapState(`analytics/constructor`, ['propertiesTree']),
      allProps(){
        return this.propertiesTree.concat([{name: 'Оргструктура', id: 'root_org', children: this.treedata}])
      }
    },
    
    data() {
      return {
        treedata: [],
        properties: [],
        tree: [],
        result: ''
      }
    },
    
    methods : {
      submit() {
        this.$emit('save', {type: 'selectProperties', data:{ name: this.result, properties: this.properties}} )
      }
    },
  
    watch:{
      tree(val){
        let tree = val.filter( item => (item.element_type && item.element_type!=='folder'))
        let properties = [], name = '', separator = '';
        tree.map( (item, index) => {
          if(item.element_type && tree.findIndex(el=>el.id===item.parent_id)<0){
            if(item.element_type==='property'){
              properties.push({
                element_type: item.element_type,
                identified: item.name,
                property_id: item.id,
              })
            } else {
              properties.push({
                element_type: item.element_type,
                identified: item.id,
              })
            }
            name = name+item.name+' -> '
          }
        })
        this.result = name.slice(0, -3)
        this.properties = properties
      }
    }
    
  }
</script>

<style scoped>
  .properties-sticky-resultblock{
    position: sticky;
    top: 0;
    background: white;
  }
</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/FilterPropertiesForm.vue